import type { GroupPublic } from '@repo/types/groups';
import type { UserPublic } from '@repo/types/users';

import { useState } from 'react';
import { useWatch } from 'react-hook-form';

import { useQuizBuilder } from '@/context/quiz-builder';
import { useQuizSettingsOverviewData } from '@/hooks/quiz';

export function useQuizBuilderSettings() {
  const { sectionsForm, usersForm, optionsForm } = useQuizBuilder();

  // Watched members
  const users: UserPublic[] = useWatch({
    name: 'users',
    control: usersForm.control,
  });
  const groups: GroupPublic[] = useWatch({
    name: 'groups',
    control: usersForm.control,
  });

  // Derived overview counts
  const { pointsCount, questionsCount, sectionsCount } = useQuizSettingsOverviewData(sectionsForm.getValues('content'));

  // Dialog state
  const [membersDialogOpen, setMembersDialogOpen] = useState<boolean>(false);

  // Mutators
  const setUsers = (next: UserPublic[]) => usersForm.setValue('users', next, { shouldDirty: true, shouldTouch: true });

  const setGroups = (next: GroupPublic[]) =>
    usersForm.setValue('groups', next, {
      shouldDirty: true,
      shouldTouch: true,
    });

  const removeUser = (id: number) => setUsers(users.filter((u) => u.id !== id));
  const removeGroup = (id: number) => setGroups(groups.filter((g) => g.id !== id));

  return {
    // forms
    sectionsForm,
    usersForm,
    optionsForm,

    // members
    users,
    groups,
    setUsers,
    setGroups,
    removeUser,
    removeGroup,

    // dialog
    membersDialogOpen,
    setMembersDialogOpen,

    // overview
    pointsCount,
    questionsCount,
    sectionsCount,
  };
}
